import { render, staticRenderFns } from "./quick-top-up.vue?vue&type=template&id=7bbc52ba&scoped=true&"
import script from "./quick-top-up.vue?vue&type=script&lang=js&"
export * from "./quick-top-up.vue?vue&type=script&lang=js&"
import style0 from "./quick-top-up.vue?vue&type=style&index=0&id=7bbc52ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc52ba",
  null
  
)

export default component.exports